import React from 'react';
import { Modal } from './ui/Modal';
interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsModal({
  isOpen,
  onClose
}: TermsModalProps) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Términos y Condiciones" data-id="element-310">
      <div className="prose prose-sm max-w-none text-gray-700 space-y-6" data-id="element-311">
        <p className="text-sm text-gray-500 italic" data-id="element-312">
          Última actualización: Diciembre 2024
        </p>

        <section data-id="element-313">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-314">
            1. Aceptación de los Términos
          </h3>
          <p data-id="element-315">
            Al acceder y realizar la compra de "Casa Impecable con 2
            Ingredientes", aceptas estar legalmente vinculado por estos términos
            y condiciones. Si no estás de acuerdo con alguna parte de estos
            términos, no debes realizar la compra.
          </p>
        </section>

        <section data-id="element-316">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-317">
            2. Descripción del Producto
          </h3>
          <p data-id="element-318">
            "Casa Impecable con 2 Ingredientes" es un producto digital (ebook)
            que incluye:
          </p>
          <ul className="list-disc pl-6 space-y-1" data-id="element-319">
            <li data-id="element-320">Ebook principal en formato PDF</li>
            <li data-id="element-321">Bono 1: Sistema Antirresbalones (PDF)</li>
            <li data-id="element-322">Bono 2: Antídoto Contra la Culpa (PDF)</li>
            <li data-id="element-323">Bono 3: La Compañera Invisible (PDF)</li>
            <li data-id="element-324">Materiales complementarios (checklists, calendarios)</li>
          </ul>
        </section>

        <section data-id="element-325">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-326">
            3. Precio y Pago
          </h3>
          <p data-id="element-327">
            El precio actual es de $12.97 USD (oferta especial de Navidad). Los
            precios están sujetos a cambios sin previo aviso. El pago se procesa
            de forma segura a través de nuestros procesadores de pago
            autorizados.
          </p>
        </section>

        <section data-id="element-328">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-329">
            4. Entrega del Producto
          </h3>
          <p data-id="element-330">
            Tras completar el pago, recibirás acceso inmediato al producto
            digital vía correo electrónico. Los enlaces de descarga estarán
            disponibles durante 30 días desde la fecha de compra. Es tu
            responsabilidad descargar y guardar los archivos.
          </p>
        </section>

        <section data-id="element-331">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-332">
            5. Garantía de Devolución de 30 Días
          </h3>
          <p data-id="element-333">
            Ofrecemos una garantía de satisfacción de 30 días. Si no estás
            satisfecha con el producto, puedes solicitar un reembolso completo
            dentro de los 30 días posteriores a la compra enviando un correo a
            soporte@casaimpecable.com. No se requieren explicaciones.
          </p>
        </section>

        <section data-id="element-334">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-335">
            6. Propiedad Intelectual
          </h3>
          <p data-id="element-336">
            Todo el contenido de "Casa Impecable con 2 Ingredientes" está
            protegido por derechos de autor. Al comprar, obtienes una licencia
            de uso personal no transferible. No está permitido:
          </p>
          <ul className="list-disc pl-6 space-y-1" data-id="element-337">
            <li data-id="element-338">Compartir, distribuir o revender el contenido</li>
            <li data-id="element-339">Reproducir el material para uso comercial</li>
            <li data-id="element-340">Modificar o crear obras derivadas sin autorización</li>
          </ul>
        </section>

        <section data-id="element-341">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-342">
            7. Limitación de Responsabilidad
          </h3>
          <p data-id="element-343">
            El contenido de este ebook es solo para fines informativos y
            educativos. Los resultados pueden variar según cada persona. No nos
            hacemos responsables de daños directos, indirectos o consecuentes
            derivados del uso del producto.
          </p>
        </section>

        <section data-id="element-344">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-345">
            8. Modificaciones
          </h3>
          <p data-id="element-346">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Las modificaciones entrarán en vigor inmediatamente después
            de su publicación en nuestro sitio web.
          </p>
        </section>

        <section data-id="element-347">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-348">9. Contacto</h3>
          <p data-id="element-349">
            Para cualquier pregunta sobre estos términos, contáctanos en:
            <br data-id="element-350" />
            Email: soporte@casaimpecable.com
            <br data-id="element-351" />
            Desarrollado por Emily Graterol
          </p>
        </section>
      </div>
    </Modal>;
}